import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';

const RedirectToLogin: React.FC = () => {
  const { pathname, search } = useLocation();
  const redirect = encodeURIComponent(pathname + search);

  return <Navigate to={`/login?redirect=${redirect}`} replace />;
};

export default RedirectToLogin;
